import { DisplayOptions, DisplayOptionStorage } from '../interfaces/display-options';
import { range } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HierarchyFiltersCustomOptions } from '../components/main-filters/hierarchy-filter-options/hierarchy-flters-custom-options';
import { IPosition } from '../../production/interfaces/production-turn-times/production-turn-times';

export interface USAState {
    name: string;
    abbreviation: string;
}

export interface ICaretInfo {
    color: string;
    caret_icon: string;
    ng_caret_icon: string;
    svgData: string;
    comparison: string;
}

export interface CategoryGroup {
    name: string;
    categories: Array<string> | CategoryGroup[];
}

export interface ICamparisonInfo {
    comparisonValue: number;
    percentage: number;
    isComparable: boolean;
}

export enum BulkUserActions {
    ConvertFromEmployee,
    ResendWelcomeEmail,
}

export enum ObfuscateVisibilityPosition {
    Start = 1,
    End,
    Both,
}

export enum ObfuscationMethod {
    ReturnInitialOnly = 1,
    UseObfuscateRoutine,
}
@Injectable({
    providedIn: 'root',
})
export class ReusableFunctions {
    constructor(private _router?: Router) {}
    // Get the maximum value from a object list based on the given parameter
    getMaxValue(dataSet: any, parameter): number {
        return Math.max.apply(
            Math,
            dataSet.map(function (o) {
                return o[parameter];
            })
        );
    }

    // Get the minimum value from a object list based on the given parameter
    getMinValue(dataSet: any, parameter): number {
        return Math.min.apply(
            Math,
            dataSet.map(function (o) {
                return o[parameter];
            })
        );
    }

    round(value, precision) {
        var multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
    }

    months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    getMonthShortName(monthNum) {
        return this.months[monthNum];
    }

    monthNumToShortName(monthnum) {
        if (monthnum > 12) {
            throw new Error('Invalid month number.');
        }
        return this.months[monthnum - 1];
    }

    monthNumToMonthYearArray(monthnum) {
        const dateArr = monthnum.split('-');
        const month = Number(dateArr[1]);
        if (monthnum > 12) {
            throw new Error('Invalid month number.');
        }
        return [this.months[month - 1], dateArr[0]];
    }

    getShortDateFormat(dateString: string) {
        const dateArr = dateString.split(' ');
        const month = dateArr[0];
        const year = dateArr[1].slice(-2);
        const fullMonthNames = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ];
        const index = fullMonthNames.indexOf(month);
        return this.months[index] + " '" + year;
    }

    getFullDateFormat(dateString: string) {
        const dateArr = dateString.split('-');
        const month = dateArr[0];
        const year = dateArr[1];
        const fullMonthNames = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ];
        const index = this.months.indexOf(month);
        return `${fullMonthNames[index]} ${year}`;
    }

    formatPeriodData(index: number, periodData: string[]) {
        const months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ];
        const dateArr = periodData[index].split('-');
        const month = months[Number(dateArr[1]) - 1];
        const year = dateArr[0];
        return `${month} ${year}`;
    }

    // Change caret icon and the color
    getCaret(
        num: number,
        inverse: boolean,
        num2: number,
        isComparable: boolean,
        toFixed = 1
    ): ICaretInfo {
        const colorRed = '#E0000E';
        const colorGreen = '#008800';
        const svgPointDown = '0,0 4,8 8,0';
        const svgPointUp = '0,8 4,0 8,8';
        let svgPoint = '';
        const caretInfo: ICaretInfo = {
            color: '',
            caret_icon: '',
            ng_caret_icon: '',
            svgData: '',
            comparison:
                num === null
                    ? ''
                    : !isComparable
                    ? '--'
                    : ' ' + Math.abs(num).toFixed(toFixed).toString() + '%',
        };

        if (num) {
            let mainNum = this.formatMoney(Math.abs(num));
            let compareNum = Math.abs(num2).toFixed(toFixed).toString();
            let mainNoFormat = Math.abs(num).toFixed(toFixed).toString();

            if (num >= 0 && !inverse) {
                caretInfo.caret_icon = 'fas fa-caret-up';
                caretInfo.ng_caret_icon = 'fa-caret-up';
                caretInfo.color = colorGreen;
                svgPoint = svgPointUp;

                if (num2 != null) {
                    caretInfo.comparison = mainNum + ' / ' + compareNum + '%';
                }
            } else if (num < 0 && !inverse) {
                caretInfo.caret_icon = 'fas fa-caret-down';
                caretInfo.ng_caret_icon = 'fa-caret-down';
                caretInfo.color = colorRed;
                svgPoint = svgPointDown;
                if (num2 != null) {
                    caretInfo.comparison = '(' + mainNum + ')' + ' / (' + compareNum + '%)';
                } else {
                    caretInfo.comparison = '(' + mainNoFormat + '%)';
                }
            } else if (num >= 0 && inverse) {
                caretInfo.caret_icon = 'fas fa-caret-up';
                caretInfo.ng_caret_icon = 'fa-caret-up';
                svgPoint = svgPointUp;
                caretInfo.color = colorRed;
                if (num2 != null) {
                    caretInfo.comparison = mainNum + ' / ' + compareNum + '%';
                }
            } else if (num < 0 && inverse) {
                caretInfo.caret_icon = 'fas fa-caret-down';
                caretInfo.ng_caret_icon = 'fa-caret-down';
                svgPoint = svgPointDown;
                caretInfo.color = colorGreen;
                if (num2 != null) {
                    caretInfo.comparison = '(' + mainNum + ')' + ' / (' + compareNum + '%)';
                } else {
                    caretInfo.comparison = '(' + mainNoFormat + '%)';
                }
            }
            caretInfo.svgData =
                '<svg width="9" height="9">' +
                '<polygon points="' +
                svgPoint +
                '" style="fill:' +
                caretInfo.color +
                ';stroke:' +
                caretInfo.color +
                ';stroke-width:1" /></svg>';
        }
        return Object.assign({}, caretInfo);
    }

    // Format the given number to $X,XXX,xxx
    // For new uses, use formatNumber function instead
    formatMoney(amount: number, precision = 0, addParenthesisForNegative = false): string {
        let formattedValue = '';
        if (amount !== undefined) {
            const formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: precision,
            });
            // TODO: replace parseInt here and fix the precision issue
            formattedValue = formatter.format(parseInt(amount.toFixed(0)));
            if (addParenthesisForNegative && amount < 0) {
                formattedValue = '(' + formattedValue.replace('-', '') + ')';
            }
        }
        return formattedValue;
    }

    // Format the given number to X,XXX,xxx; add paranthasis if negative;
    // can be formatted for currency as well
    formatNumber(
        amount: number,
        precision = 0,
        type: 'number' | 'currency' | 'percentage' | 'money' | string = 'number',
        addParanthasisForNegative = false
    ) {
        let formattedValue = '';
        if (amount !== undefined && amount !== null) {
            let formatOptions = {
                minimumFractionDigits: precision,
                maximumFractionDigits: precision,
            };

            if (type === 'currency' || type === 'money') {
                formatOptions['style'] = 'currency';
                formatOptions['currency'] = 'USD';
            }
            const formatter = new Intl.NumberFormat('en-US', formatOptions);
            formattedValue = formatter.format(amount) + (type === 'percentage' ? '%' : '');
            if (addParanthasisForNegative && amount < 0) {
                formattedValue = '(' + formattedValue.replace('-', '') + ')';
            }
        }
        return formattedValue;
    }

    // Formats units to X,XXX,xxx
    formatUnits(units: number): string {
        const formatter = new Intl.NumberFormat('en-US', {});
        return formatter.format(parseInt(units.toFixed(0)));
    }

    // Converts all words to have uppercase first letter
    toCamelCase(str: string) {
        if (str === '') {
            return '';
        }
        let indexOfSpace = str.indexOf(' ');
        if (indexOfSpace === -1) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        } else {
            return (
                str.charAt(0).toUpperCase() +
                str.slice(1, indexOfSpace + 1) +
                this.toCamelCase(str.slice(indexOfSpace + 1))
            );
        }
    }

    //formats number to a string with a certain number a decimal points, specified by precision param.
    padToMaxPrecision(value: number, precision: number): string {
        if (precision > 0) {
            return (Math.round(value * Math.pow(10, precision)) / Math.pow(10, precision)).toFixed(
                precision
            );
        }
        return value.toString();
    }

    setDecimals(value: number, decimalPlaces: number): number {
        const x = Math.pow(10, decimalPlaces);
        return Math.round(value * x) / x;
    }

    // Calculate the sum of an array of objects by given property name
    calculateSumByProperty(dataList: Array<any>, property: string): number {
        return dataList.reduce((a, b) => a + (b[property] || 0), 0);
    }

    calculateComparisonPercentage(currentValue: number, compareToValue: number): ICamparisonInfo {
        let compareInfo: ICamparisonInfo = {
            comparisonValue: 0,
            percentage: 0,
            isComparable: false,
        };

        if (currentValue === null) {
            currentValue = 0;
        }

        if (compareToValue === null) {
            compareToValue = 0;
        }
        const comparisonValue = currentValue - compareToValue;

        let percentage = 0;
        if (compareToValue !== 0) {
            percentage = (comparisonValue * 100.0) / compareToValue;
            compareInfo.isComparable = true;
        } else {
            compareInfo.isComparable = false;
        }

        compareInfo.comparisonValue = comparisonValue;
        compareInfo.percentage = percentage;
        return compareInfo; //[comparisonValue, percentage];
    }

    getDifferenceOf2Arrays(array1: Array<any>, array2: Array<any>): Array<any> {
        return array1.concat(array2).filter(function (val) {
            if (!(array1.includes(val) && array2.includes(val))) {
                return val;
            }
        });
    }

    hasTheGivenObjectIntheArray(givenObject: object, givenArray: Array<any>, property: string) {
        if (givenArray && givenArray.length > 0 && givenObject) {
            let commonObject = givenArray.find((item) => {
                item[property] === givenObject[property];
            });

            if (commonObject) {
                return true;
            }
            return false;
        }
        return false;
    }

    // This gives unique item list for a given property in an array of oblects
    getUniqueItemList(array: Array<any>, columnNameToFindUniqueVal: string): Array<any> {
        return array
            .map((item) => item[columnNameToFindUniqueVal])
            .filter((value, index, self) => self.indexOf(value) === index);
    }

    getColorOptions(page: string, sub?: string) {
        switch (page) {
            case 'historical': {
                return { 1: '#6BAD38', 2: '#AF6EE8', 3: '#FF3838', 4: '#41D6C3', 5: '#FDD600' };
            }
            default: {
                break;
            }
        }
    }

    // Generic toggle function
    switchFlag(value) {
        value = !value;
    }

    removeDuplicates(arrayOfObjects: Array<any>) {
        arrayOfObjects = arrayOfObjects.filter((item, index) => {
            return (
                index ===
                arrayOfObjects.findIndex((obj) => {
                    return JSON.stringify(obj) === JSON.stringify(item);
                })
            );
        });
    }

    getHierarchyFilters(): string {
        let hierarchyCacheInfo = new HierarchyFiltersCustomOptions();
        return hierarchyCacheInfo.getHierarchyFilters(this._router.url.split('?')[0]);
    }

    getCurrentDisplayOptions(optionUrl: string): DisplayOptions[] {
        let storageName = 'displayOptionsStorage';
        let displayOptionsLocalStorage: DisplayOptionStorage[] = JSON.parse(
            localStorage.getItem(storageName)
        );
        let defaultDisplayOptions: DisplayOptions[] = this.getDefaultDisplayOptions(optionUrl);

        let displayOptionsInfo: DisplayOptionStorage;
        if (displayOptionsLocalStorage) {
            displayOptionsInfo = displayOptionsLocalStorage.find(
                (option) => option.optionName === optionUrl
            );

            if (displayOptionsInfo) {
                let appCurrentVersion = localStorage.getItem('version');

                if (displayOptionsInfo.version !== appCurrentVersion) {
                    displayOptionsLocalStorage = displayOptionsLocalStorage.filter(
                        (item) => item.optionName !== displayOptionsInfo.optionName
                    );
                    localStorage.setItem(storageName, JSON.stringify(displayOptionsLocalStorage));
                    return defaultDisplayOptions;
                }
            }

            if (displayOptionsInfo && displayOptionsInfo.optionValues) {
                let yearDdlOptions = displayOptionsInfo.optionValues.find(
                    (item) => item.optionKey === 'yearsDdl'
                );
                if (yearDdlOptions) {
                    let defaultSelection = defaultDisplayOptions.find(
                        (item) => item.optionKey === 'yearsDdl'
                    );

                    if (defaultSelection) {
                        // TODO; is this necessary? Seems like not using
                        yearDdlOptions = {
                            isMultiSelection: defaultSelection.isMultiSelection,
                            isUsedForGetDateRange: defaultSelection.isUsedForGetDateRange,
                            optionKey: defaultSelection.optionKey,
                            selectedOptionList: defaultSelection.selectedOptionList,
                            selectedOptions: defaultSelection.selectedOptions,
                            selectedOptionsFriendly: defaultSelection.selectedOptionsFriendly,
                            dateRangeType: defaultSelection.dateRangeType,
                        };
                    }

                    displayOptionsInfo.optionValues.find(
                        (item) => item.optionKey === 'yearsDdl'
                    ).selectedOptionList = defaultSelection.selectedOptionList;
                }
                localStorage.setItem(
                    'displayOptionsStorage',
                    JSON.stringify(displayOptionsLocalStorage)
                );

                return displayOptionsInfo.optionValues;
            }
        }
        return defaultDisplayOptions;
    }

    getDefaultDisplayOptions(url: string) {
        let defaultDisplayOptions: DisplayOptions[] = [];
        let tempDefaultDisplayOptionStorage: DisplayOptionStorage[] = JSON.parse(
            localStorage.getItem('tempDefaultDisplayOptionStorage')
        );

        let defaultDisplayOptionItem = tempDefaultDisplayOptionStorage.find(
            (item) => item.optionName.toLowerCase() === url.toLowerCase()
        );
        if (defaultDisplayOptionItem) {
            defaultDisplayOptions = defaultDisplayOptionItem.optionValues;
        }
        return defaultDisplayOptions;
    }

    formatTitle(milestoneToDisplay: string): string {
        return milestoneToDisplay.toLowerCase().split(' ').join('-');
    }

    removePreviousFromUrlSegment(urlSegment: string): string {
        return urlSegment.toLocaleLowerCase().replace('-previous', '');
    }

    // This function give a sort string to sort alpha numeric values
    //Ex:
    // arrayOfObjects.sort((a, b) => this.reusableFunctions.sortAlphaNumeric(a.propertyName, b.propertyName));
    sortAlphaNumeric(a: string, b: string) {
        const collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'base',
        });
        return collator.compare(a, b);
    }

    getMonthName(monthNum: number) {
        interface IMonth {
            num: number;
            shortMonth: string;
            fullMonth: string;
        }

        let monthDetails: IMonth[] = [
            { num: 1, shortMonth: 'Jan', fullMonth: 'January' },
            { num: 2, shortMonth: 'Feb', fullMonth: 'February' },
            { num: 3, shortMonth: 'Mar', fullMonth: 'March' },
            { num: 4, shortMonth: 'Apr', fullMonth: 'April' },
            { num: 5, shortMonth: 'May', fullMonth: 'May' },
            { num: 6, shortMonth: 'Jun', fullMonth: 'June' },
            { num: 7, shortMonth: 'Jul', fullMonth: 'July' },
            { num: 8, shortMonth: 'Aug', fullMonth: 'August' },
            { num: 9, shortMonth: 'Sep', fullMonth: 'September' },
            { num: 10, shortMonth: 'Oct', fullMonth: 'October' },
            { num: 11, shortMonth: 'Nov', fullMonth: 'November' },
            { num: 12, shortMonth: 'Dec', fullMonth: 'December' },
        ];

        return monthDetails.find((item) => item.num === monthNum);
    }

    // Format dates to "January 1, 2018" format
    formatDate(dateString: string) {
        let date = new Date(dateString);
        let day = date.getUTCDate();
        let monthIndex = date.getUTCMonth();
        let year = date.getUTCFullYear();

        return (
            this.getMonthName(monthIndex + 1).fullMonth +
            ' ' +
            day.toString() +
            ', ' +
            year.toString()
        );
    }

    getDateFromDateTimeOffset(dateTime: Date | string) {
        if (dateTime) {
            let dt = new Date(dateTime);
            return new Date(dt.getUTCFullYear(), dt.getUTCMonth(), dt.getUTCDate());
        }
        return null;
    }

    isDateInTheFuture(dateTime: Date | string) {
        //return true if passed in date is a future date from today.
        let dateToCheck = new Date(dateTime);
        let today = new Date();
        if (dateToCheck.getUTCFullYear() > today.getUTCFullYear()) {
            return true;
        }
        if (dateToCheck.getUTCFullYear() < today.getUTCFullYear()) {
            return false;
        }
        //years are the same, check month
        if (dateToCheck.getUTCMonth() > today.getUTCMonth()) {
            return true;
        }
        if (dateToCheck.getUTCMonth() < today.getUTCMonth()) {
            return false;
        }
        //year and month are same, check date
        if (dateToCheck.getUTCDate() > today.getUTCDate()) {
            return true;
        }
        return false;
    }

    // Returns formatted initials string
    getFormattedInitials(value: string) {
        let returnData = '';

        let matches = value.match(/\b(\w)/g);
        if (matches.length == 3) {
            // Remove middle initial from hyphen or 3 part name
            matches.splice(1, 1);
        }

        returnData = matches.join('');
        returnData = returnData.split('').reverse().join('');

        return returnData;
    }

    getCurrentDateTimeOffset(): string {
        var dateObj = new Date();
        var month = dateObj.getUTCMonth() + 1;
        var day = dateObj.getUTCDate();
        var year = dateObj.getUTCFullYear();
        var hours = dateObj.getUTCHours();
        var minutes = dateObj.getUTCMinutes();
        var seconds = dateObj.getUTCSeconds();

        return month + '/' + day + '/' + year + ' ' + hours + ':' + minutes + ':' + seconds;
    }

    getCurrentDate(): string {
        var dateObj = new Date();
        var month = dateObj.getUTCMonth() + 1;
        var day = dateObj.getUTCDate();
        var year = dateObj.getUTCFullYear();

        return month + '/' + day + '/' + year;
    }

    indexOfMax(arr: number[]) {
        if (arr.length === 0) {
            return -1;
        }

        var max = arr[0];
        var maxIndex = 0;

        for (var i = 1; i < arr.length; i++) {
            if (arr[i] > max) {
                maxIndex = i;
                max = arr[i];
            }
        }

        return maxIndex;
    }

    indexOfMin(arr: number[]) {
        if (arr.length === 0) {
            return -1;
        }

        var min = arr[0];
        var minIndex = 0;

        for (var i = 1; i < arr.length; i++) {
            if (arr[i] < min) {
                minIndex = i;
                min = arr[i];
            }
        }

        return minIndex;
    }

    sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    getChartXLabel(dateRange: string): string {
        let xTitle = 'Business Day';
        if (
            dateRange.toLowerCase().search('year') > -1 ||
            dateRange.toLowerCase().search('12m') > -1 ||
            dateRange.toLowerCase().search('6m') > -1 ||
            dateRange.toLowerCase().search('3m') > -1
        ) {
            xTitle = 'Month';
        } else if (dateRange.toLowerCase().search('quarter') > -1) {
            xTitle = 'Week';
        }
        return xTitle;
    }

    setXValues(grp, dateRange, prop1 = 'period', prop2 = 'datePeriodDescription') {
        let label = Object.assign({}, grp)[prop1];
        if (this.getChartXLabel(dateRange) === 'Month') {
            label = grp[prop2].slice(0, 3);
        }
        return label;
    }

    getCategories(incommingData, propertyList: string[], dateRange) {
        let data = incommingData.map((obj) => ({ ...obj }));

        let mainGroupList = this.getUniqueItemList(data, propertyList[0]);
        let categGroup: CategoryGroup[] = [];
        let allLabelList = this.getUniqueItemList(data, propertyList[1]);

        if (mainGroupList.length > 1) {
            for (let mainItem of mainGroupList) {
                let mainCategoryData = data.filter((item) => item[propertyList[0]] === mainItem);
                if (mainCategoryData.length > 0 && propertyList[1]) {
                    categGroup.push({ name: mainItem, categories: [] });

                    let periodList = this.getUniqueItemList(mainCategoryData, propertyList[1]);
                    let catg = categGroup.find((item) => item.name === mainItem);

                    let prop2 = 'datePeriodDescription';
                    if (propertyList[2]) {
                        prop2 = propertyList[2];
                    }

                    periodList.forEach((itm) => {
                        catg.categories.push(
                            this.setXValues(
                                mainCategoryData.find(
                                    (item) =>
                                        item[propertyList[0]] === mainItem &&
                                        item[propertyList[1]] === itm
                                ),
                                dateRange,
                                propertyList[1],
                                prop2
                            )
                        );
                    });
                }
            }
            return [categGroup.length > 1 ? categGroup : null, allLabelList];
        } else {
            return [null, allLabelList];
        }
    }

    vowelRegex = new RegExp('^[aeiou].*', 'i');
    startsWithVowel(word: string): boolean {
        return this.vowelRegex.test(word);
    }

    getUSAStatesJson() {
        return [
            {
                name: 'Alabama',
                abbreviation: 'AL',
            },
            {
                name: 'Alaska',
                abbreviation: 'AK',
            },
            {
                name: 'American Samoa',
                abbreviation: 'AS',
            },
            {
                name: 'Arizona',
                abbreviation: 'AZ',
            },
            {
                name: 'Arkansas',
                abbreviation: 'AR',
            },
            {
                name: 'California',
                abbreviation: 'CA',
            },
            {
                name: 'Colorado',
                abbreviation: 'CO',
            },
            {
                name: 'Connecticut',
                abbreviation: 'CT',
            },
            {
                name: 'Delaware',
                abbreviation: 'DE',
            },
            {
                name: 'District Of Columbia',
                abbreviation: 'DC',
            },
            {
                name: 'Federated States Of Micronesia',
                abbreviation: 'FM',
            },
            {
                name: 'Florida',
                abbreviation: 'FL',
            },
            {
                name: 'Georgia',
                abbreviation: 'GA',
            },
            {
                name: 'Guam',
                abbreviation: 'GU',
            },
            {
                name: 'Hawaii',
                abbreviation: 'HI',
            },
            {
                name: 'Idaho',
                abbreviation: 'ID',
            },
            {
                name: 'Illinois',
                abbreviation: 'IL',
            },
            {
                name: 'Indiana',
                abbreviation: 'IN',
            },
            {
                name: 'Iowa',
                abbreviation: 'IA',
            },
            {
                name: 'Kansas',
                abbreviation: 'KS',
            },
            {
                name: 'Kentucky',
                abbreviation: 'KY',
            },
            {
                name: 'Louisiana',
                abbreviation: 'LA',
            },
            {
                name: 'Maine',
                abbreviation: 'ME',
            },
            {
                name: 'Marshall Islands',
                abbreviation: 'MH',
            },
            {
                name: 'Maryland',
                abbreviation: 'MD',
            },
            {
                name: 'Massachusetts',
                abbreviation: 'MA',
            },
            {
                name: 'Michigan',
                abbreviation: 'MI',
            },
            {
                name: 'Minnesota',
                abbreviation: 'MN',
            },
            {
                name: 'Mississippi',
                abbreviation: 'MS',
            },
            {
                name: 'Missouri',
                abbreviation: 'MO',
            },
            {
                name: 'Montana',
                abbreviation: 'MT',
            },
            {
                name: 'Nebraska',
                abbreviation: 'NE',
            },
            {
                name: 'Nevada',
                abbreviation: 'NV',
            },
            {
                name: 'New Hampshire',
                abbreviation: 'NH',
            },
            {
                name: 'New Jersey',
                abbreviation: 'NJ',
            },
            {
                name: 'New Mexico',
                abbreviation: 'NM',
            },
            {
                name: 'New York',
                abbreviation: 'NY',
            },
            {
                name: 'North Carolina',
                abbreviation: 'NC',
            },
            {
                name: 'North Dakota',
                abbreviation: 'ND',
            },
            {
                name: 'Northern Mariana Islands',
                abbreviation: 'MP',
            },
            {
                name: 'Ohio',
                abbreviation: 'OH',
            },
            {
                name: 'Oklahoma',
                abbreviation: 'OK',
            },
            {
                name: 'Oregon',
                abbreviation: 'OR',
            },
            {
                name: 'Palau',
                abbreviation: 'PW',
            },
            {
                name: 'Pennsylvania',
                abbreviation: 'PA',
            },
            {
                name: 'Puerto Rico',
                abbreviation: 'PR',
            },
            {
                name: 'Rhode Island',
                abbreviation: 'RI',
            },
            {
                name: 'South Carolina',
                abbreviation: 'SC',
            },
            {
                name: 'South Dakota',
                abbreviation: 'SD',
            },
            {
                name: 'Tennessee',
                abbreviation: 'TN',
            },
            {
                name: 'Texas',
                abbreviation: 'TX',
            },
            {
                name: 'Utah',
                abbreviation: 'UT',
            },
            {
                name: 'Vermont',
                abbreviation: 'VT',
            },
            {
                name: 'Virgin Islands',
                abbreviation: 'VI',
            },
            {
                name: 'Virginia',
                abbreviation: 'VA',
            },
            {
                name: 'Washington',
                abbreviation: 'WA',
            },
            {
                name: 'West Virginia',
                abbreviation: 'WV',
            },
            {
                name: 'Wisconsin',
                abbreviation: 'WI',
            },
            {
                name: 'Wyoming',
                abbreviation: 'WY',
            },
        ];
    }

    createHubSpotUrl(s: string) {
        var str: string = '';
        str.concat('https://app.hubspot.com/contacts/5208514/company/', s, '/');
        return str;
    }
    createCompenSafeUrl(s: string) {
        var str: string = '';
        str.concat('https://', s, '.compensafe.com/Dashboard.aspx');
        return str;
    }

    getPercentInfo(thisPeriodTotal: number, lastPeriodTotal: number, isInverse: boolean) {
        const comparison = this.calculateComparisonPercentage(thisPeriodTotal, lastPeriodTotal);
        let caretInfo = this.getCaret(
            comparison.percentage,
            isInverse,
            null,
            comparison.isComparable,
            1
        );
        return {
            percentValue: caretInfo.comparison,
            percentColor: caretInfo.color,
            caret: caretInfo.caret_icon,
        };
    }

    // format large number with abbreviation
    formatLargeNumber(num: number): string {
        if (num >= 1000000000000) {
            return (num / 1000000000000).toFixed(1) + 'T';
        } else if (num >= 1000000000) {
            return (num / 1000000000).toFixed(1) + 'B';
        } else if (num >= 1000000) {
            return (num / 1000000).toFixed(1) + 'M';
        } else if (num >= 1000) {
            return (num / 1000).toFixed(1) + 'K';
        } else {
            return num.toString();
        }
    }

    getPurposeColor(purpose: string): string {
        switch (purpose && purpose.toLowerCase()) {
            case 'refinance':
            case 'refi':
                return '#669999';
            case 'construction':
            case 'const':
                return '#9FA278';
            case 'purchase':
            case 'purch':
                return '#FF9966';
            case 'modification':
            case 'modif':
                return '#007ba7';
            case 'other':
                return '#6893B9';
            default:
                return '#000000';
        }
    }

    getLoanTypeColor(loanTypeCategory: string): string {
        switch (loanTypeCategory.toLowerCase()) {
            case 'govt':
            case 'government':
                return '#57D785';
            case 'conv':
            case 'conventional':
                return '#B870FF';
            case 'jumbo':
                return '#FFDB70';
            case 'other':
                return '#FF9494';
            case 'reverse':
                return '#2C76A2';
            case 'non-conf':
            case 'non conforming':
                return '#FFDB70';
            default:
                return '#000000';
        }
    }

    getECloseColors(includeJustDefaults: boolean = false) {
        const colorObject = {
            'Full eClose': '#9D02D7',
            Hybrid: '#006444',
            'Hybrid eNote': '#CDC98C',
            'Hybrid RON': '#E7298A',
            Traditional: '#003399',
        };

        if (!includeJustDefaults) {
            colorObject['default'] = '#CE7DA5';
            colorObject['All Loans'] = '#52C9E7ED';
            colorObject['eClose Only'] = '#CE7DA5';
        }

        return colorObject;
    }

    getCompSnapshotColors() {
        const colorObject = {
            Commission: '#B871FF',
            'Earnings Recapture': '#EA4A22',
            Bonus: '#2978A8',
            Override: '#FFCC33',
            Marketing: '57D786',
            Other: '#004D40',
        };

        return colorObject;
    }

    getLegendIndex() {
        return {
            Purch: 0,
            Purchase: 0,
            Refi: 1,
            Refinance: 1,
            Const: 2,
            Construction: 2,
            Modification: 3,
            Modif: 3,
            Other: 4,
            Conv: 0,
            Conventional: 0,
            Govt: 1,
            Government: 1,
            'Non-Conf': 2,
            'Non conforming': 2,
            'NON-CONF': 2,
            Reverse: 3,
            REVERSE: 3,
            Canceled: 0,
            Denied: 1,
            Withdrawn: 2,
            Inactive: 3,
        };
    }

    getProperTitleFromAbbrLoanTypeLoanPurpose(abbr: string): string {
        switch (abbr.toLowerCase()) {
            case 'conv':
                return 'Conventional';
            case 'govt':
                return 'Government';
            case 'jumbo':
                return 'Jumbo';
            case 'other':
                return 'Other';
            case 'purch':
            case 'purchase':
                return 'Purchase';
            case 'refi':
            case 'refinance':
                return 'Refinance';
            case 'const':
            case 'construction':
                return 'Construction';
            case 'investment':
                return 'Investment';
            case 'second':
                return 'Second';
            case 'principal':
                return 'Principal';
            case 'non-conf':
                return 'Non Conforming';
            case 'reverse':
                return 'Reverse';
            default:
                throw new Error('Name not defined for this abbreviation: ' + abbr);
        }
    }

    getUniqueId(url: string, urlSegment: string) {
        let urlitems = (url + urlSegment).split('/');
        let id1 = urlitems[urlitems.length - 2] ? urlitems[urlitems.length - 2] : 'id-first';
        let id2 = urlitems[urlitems.length - 1] ? urlitems[urlitems.length - 1] : 'id-second';
        return (id1 + id2).toLowerCase();
    }

    getCurrentDateTimeStamp(dateString?: string) {
        let today = new Date();

        if (dateString) {
            today = new Date(dateString);
        }

        let dateTime =
            today.getFullYear() +
            '_' +
            (today.getMonth() + 1) +
            '_' +
            today.getDate() +
            '_' +
            today.getHours() +
            '_' +
            today.getMinutes() +
            '_' +
            today.getSeconds();
        return dateTime;
    }

    getPositionList() {
        /*
            TODO:
                get from hierarchy filter position logic and save in local storage for the first time,
                and retrive from there.
        */
        let positionList = [
            { positionIdentifier: '1', position: 'Loan Originator' },
            { positionIdentifier: '2', position: 'Processor' },
            { positionIdentifier: '3', position: 'Underwriter' },
            { positionIdentifier: '4', position: 'Closer' },
        ];

        let nonStandardPoisionUrlList = ['/pipeline/insights/pipeline-with-position-assigned'];

        let nonStandardPositionUrl = nonStandardPoisionUrlList.find(
            (url) => url === this._router.url
        );

        if (nonStandardPositionUrl) {
            positionList.push({ positionIdentifier: '11', position: 'Account Executive' });
            positionList.push({ positionIdentifier: '9', position: 'Loan Originator Assistant'});
            //positionList.push({ positionIdentifier: '13', position: 'Funder' });
        }
        return positionList;
    }

    getPosition(positionId) {
        let selectedPosition: IPosition = JSON.parse(localStorage.getItem('selected-position'));
        let positionList = this.getPositionList();

        let isSelectedPositionInTheList = positionList.find(
            (pos) => pos.positionIdentifier === selectedPosition?.positionIdentifier
        );
        if (!selectedPosition || !isSelectedPositionInTheList) {
            selectedPosition = positionList[positionId];
        }

        return {
            selectedPosition: selectedPosition,
            positionList: positionList,
        };
    }

    obfuscate(
        valueToObfuscate: string,
        visibilityAt: ObfuscateVisibilityPosition,
        visibleCharacterCount: number = 4,
        obfuscateWithChar: string = 'X'
    ): string {
        let obfuscated = Array.from(valueToObfuscate);
        if (visibilityAt === ObfuscateVisibilityPosition.End) {
            obfuscated = obfuscated.reverse();
        }

        switch (visibilityAt) {
            case ObfuscateVisibilityPosition.Start:
            case ObfuscateVisibilityPosition.End:
                range(
                    visibleCharacterCount,
                    valueToObfuscate.length - visibleCharacterCount
                ).subscribe((x) => {
                    obfuscated[x] = obfuscateWithChar;
                });
                break;
            case ObfuscateVisibilityPosition.Both:
                range(
                    Math.floor(visibleCharacterCount / 2),
                    valueToObfuscate.length - visibleCharacterCount
                ).subscribe((x) => {
                    obfuscated[x] = obfuscateWithChar;
                });
        }

        if (visibilityAt === ObfuscateVisibilityPosition.End) {
            obfuscated = obfuscated.reverse();
        }
        return obfuscated.join('');
    }

    getCorporateIdentifiers(): string[] {
        return [
            'INC',
            'LLC',
            'Company',
            'LTD',
            'Group',
            'Corp',
            'Corporation',
            'Partners',
            'Limited',
        ];
    }

    isCorporateName(name: string): boolean {
        const corporateIdentifiers = this.getCorporateIdentifiers();
        const words = name.match(/(\w+)/g);
        let isCorporate: boolean = false;
        words.forEach((word) => {
            const regEx = new RegExp(`^${word}$`, 'gi');
            corporateIdentifiers.forEach((corpWord) => {
                isCorporate = isCorporate || regEx.test(corpWord);
                if (isCorporate) return isCorporate;
            });
        });
        return isCorporate;
    }

    getCorporateName(
        name: string,
        obfuscateName: boolean = false,
        obfuscationMethod: ObfuscationMethod = ObfuscationMethod.ReturnInitialOnly
    ) {
        try {
            if (!obfuscateName) return name;
            const corporateIdentifiers = this.getCorporateIdentifiers();
            const words = name.match(/(\w+)/g);
            const cleanCorpName: string[] = [];
            words.forEach((word) => {
                const regEx = new RegExp(`^${word}$`, 'gi');
                let isCorpWord: boolean = false;
                for (const corpWord of corporateIdentifiers) {
                    isCorpWord = isCorpWord || regEx.test(corpWord);
                }
                if (isCorpWord) {
                    cleanCorpName.push(word);
                } else {
                    if (obfuscationMethod === ObfuscationMethod.ReturnInitialOnly) {
                        cleanCorpName.push(word.substr(0, 1));
                    } else {
                        cleanCorpName.push(
                            this.obfuscate(word, ObfuscateVisibilityPosition.Start, 1, '*')
                        );
                    }
                }
            });
            return cleanCorpName.join(' ').trim();
        } catch (err) {
            return obfuscateName ? undefined : name;
        }
    }

    getFirstName(
        fullName: string,
        initialsOnly: boolean = false,
        handleCorpAsIndividual: boolean = false
    ) {
        try {
            let name = fullName.trim();
            if (this.isCorporateName(name) && !handleCorpAsIndividual) return name;
            const hasCommaSeparator: boolean = name.indexOf(',') > -1;

            let parts: string[] = name.match(/(\w+)/g);
            if (hasCommaSeparator) {
                if (parts.length > 1) {
                    parts.splice(0, 1);
                    let firstName = parts.join(' ').trim();
                    if (!initialsOnly) {
                        return firstName;
                    }
                    return firstName
                        .match(/\b(\w)/g)
                        .join(' ')
                        .trim();
                } else {
                    if (!initialsOnly) {
                        return parts[0].trim();
                    }
                    return parts[0].substr(0, 1);
                }
            } else {
                if (!initialsOnly) {
                    return parts[0].trim();
                }
                return parts[0].substr(0, 1);
            }
        } catch (e) {
            return fullName;
        }
    }

    getLastName(fullName: string, handleCorpAsIndividual: boolean = false) {
        try {
            let name = fullName.trim();
            if (this.isCorporateName(name) && !handleCorpAsIndividual) return name;
            const hasCommaSeparator: boolean = name.indexOf(',') > -1;

            let parts: string[] = name.match(/(\w+)/g);
            if (hasCommaSeparator) {
                return parts[0].trim();
            } else {
                if (parts.length > 1) {
                    const lastWordIndex = parts.length - 1;
                    return parts[lastWordIndex].trim();
                } else {
                    return parts[0].trim();
                }
            }
        } catch (e) {
            return fullName;
        }
    }

    getLargeCurrencyFormat(number: number) {
        const thousand = 1000;
        const million = 1000000;
        const billion = 1000000000;
        const absNumber = Math.abs(number);
        let formattedNumber = absNumber;
        let precision = 0;
        let label;
        if (absNumber > billion) {
            if (number > billion * 10) {
                precision = 1;
            } else {
                precision = 2;
            }
            label = 'B';
            formattedNumber = formattedNumber / billion;
        } else if (absNumber > million) {
            if (number > million * 10) {
                precision = 1;
            } else {
                precision = 2;
            }
            label = 'M';
            formattedNumber = formattedNumber / million;
        } else if (absNumber < million) {
            precision = 0;
            label = 'k';
            formattedNumber = formattedNumber / thousand;
        }

        const returnedString = `$${formattedNumber.toFixed(precision)}${label}`;
        return number >= 0 ? returnedString : `(${returnedString})`;
    }

    getRefinedPercents(rawPercents, desiredSum = 100) {
        let sum = 0;
        let percents = rawPercents.map((value, i) => {
            let integer = value | 0;
            sum += integer;
            return { integer };
        });

        if (sum != desiredSum) {
            percents = percents.sort((x) => x.decimal);

            const diff = desiredSum - sum;
            let i = 0;

            while (i < diff) {
                percents[i].integer++;
                i++;
            }
        }

        return percents.map((p) => p.integer);
    }

    // Input: MM-DD-YYYY, Output: Month YYYY
    getFriendlyDateMonthFirst(date) {
        if (!date) return null;
        const ymcArr = date.split('-');
        const month = ymcArr[0];
        const year = ymcArr[2];
        const fullMonthNames = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ];
        return `${fullMonthNames[month - 1]} ${year}`;
    }

    // Input: MM/DD/YYYY, Output: YYYY-MM-DD
    getDateFormat(date) {
        if (!date) return null;
        const ymcArr = date.split('/');
        const month = ymcArr[0];
        const year = ymcArr[2];
        const day = ymcArr[1];
        return `${year}-${month}-${day}`;
    }

    // Input: YYYY-MM, Output: Month YYYY
    getFriendlyDateYearFirst(date) {
        if (!date) return null;
        const ymcArr = date.split('-');
        const month = ymcArr[1];
        const year = ymcArr[0];
        const fullMonthNames = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ];
        return `${fullMonthNames[month - 1]} ${year}`;
    }

    getFriendlyTenure(currentData) {
        for (let data of currentData) {
            data['friendlyTenure'] = `${data.tenureYears}Yr ${data.tenureMonths}Mo`;
        }
        return currentData;
    }

    getRandomHexColor() {
        const randomColor = Math.floor(Math.random() * 16777215).toString(16);
        return `#${randomColor}`;
    }

    getGuid() {
        // http://www.ietf.org/rfc/rfc4122.txt
        var s = [];
        var hexDigits = '0123456789abcdef';
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = '-';

        var uuid = s.join('');
        return uuid;
    }
}
